import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './FlipDisplay.module.scss'

const FlipDisplay = ({ value, fixedLength, fillChar, className, children, ...restProps }) => {
  const strVal = value.toString()
  const padLength = fixedLength || strVal.length

  // force any value to be the exact length we expect, ie 1 -> 01
  // first slice to trim excess chars for anything too long
  // then pad the right side for anything too short
  const trimVal = strVal.slice(0, padLength)
  const padTrimVal = String(trimVal).padStart(padLength, fillChar)

  return (
    <div className={classnames(styles.wrapper, className)} {...restProps}>
      <div className={styles.row}>
        {[...padTrimVal].map((char, i) => (
          <span key={`flip-char_${i}`} className={styles.character}>
            {char}
          </span>
        ))}
      </div>
      {children}
    </div>
  )
}

FlipDisplay.propTypes = {
  value: PropTypes.any.isRequired,
  fixedLength: PropTypes.number,
  fillChar: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any
}

FlipDisplay.defaultProps = {
  value: '',
  fillChar: '0'
}

export default FlipDisplay
